import type { RootState } from '@app/types';

// eslint-disable-next-line import/prefer-default-export
export const getDownloadGenerateFile = (state: RootState) => state.downloadGenerate.file;
